export default __webpack_public_path__ + "static/media/03MAR.36afe4ad.jpg";